export default "__VITE_ASSET__BaioPiV0__"